import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css'
import { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
//import { useNavigate } from 'react-router';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import httpService from '../services/httpService';
import { ApiEndpoints } from '../constants/appConstants';
import { useNavigate } from 'react-router';
//import { SortOrder } from 'primereact/api';

interface ParamsType {
    PageNumber: number;
    CountPerPage: number;
}

const ExceptionPage: React.FC = () => {
    //const navigate = useNavigate()
    const [data, setData] = useState([])
    const [filteredData, setFilteredData] = useState(data);
    const [isLoading, setLoading] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();
    const globalSearchKeys = ['Id', 'ExceptionMessage'];

    //const globalSearchKeys = ['mpi', 'providerAgencyName'];
    // api call onload
    useEffect(() => {
        setLoading(true);
        const params: ParamsType = { PageNumber: 1, CountPerPage: 10 };
        //let url = `${ApiEndpoints.GetExceptions}/1/3`;
        httpService.get(ApiEndpoints.GetExceptions, params)
            .then((response: any) => {
                setData(response?.data);
                setFilteredData(response?.data);
            }).catch((error: any) => {
                if (error.status == 403 || error.status == 401) {
                    navigate(`/unauthorized`);
                }
                console.log('Error: ', error);
            }).finally(() => {
                // console.log('Finally');
                setLoading(false);
            })
    }, [])

    const renderHeader = () => {
        return (
            <div className="flex flex-wrap gap-2 justify-content-between ">
                <IconField iconPosition="left" align-items-end>
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={handleSearch} placeholder="Search Exception" />
                </IconField>
            </div>
        );
    };

    const handleSearch = (e: any) => {
        const value = e.target.value.toLowerCase();
        const filtered = data.filter((item: any) =>
            globalSearchKeys.some((key) => String(item[key]).toLowerCase().includes(value))
        );


        setGlobalFilterValue(e.target.value);
        setFilteredData(filtered);
    }

    const header = renderHeader();



    return (
        <>

            <div className="card">
                <div>

                    <DataTable value={filteredData} paginator header={header} rows={5} rowsPerPageOptions={[5, 10, 25, 50]} loading={isLoading} tableStyle={{ minHeight: "15rem" }}
                        dataKey="Id" emptyMessage="No Exception found."
                    >

                        <Column field="createDate" header="Create Date" sortable filter filterPlaceholder="Filter by Create Date" style={{ minWidth: '14rem' }} />
                        <Column field="exceptionType" header="Exception Type" sortable filter filterPlaceholder="Filter by Exception Type" style={{ minWidth: '14rem' }} />
                        <Column field="exceptionMessage" header="Exception Message" sortable filter filterPlaceholder="Filter by Exception Maessage" style={{ minWidth: '14rem' }} />
                        <Column field="exceptionTrace" header="Exception Trace" sortable filter filterPlaceholder="Filter by Exception Tarce" style={{ minWidth: '14rem' }} />
                    </DataTable>
                </div>
            </div >
        </>
    )
}

export default ExceptionPage;